<template>
  <v-row>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline"
            >Veuillez saisir la raison du retour du dossier</span
          >
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-textarea
              name="input-7-1"
              filled
              auto-grow
              v-model="motif"
            ></v-textarea>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="text-center">
            <v-btn class="mx-2 primary" @click="continuerMotif">
              <v-icon left>save</v-icon>
              Continuer
            </v-btn>
            <v-btn class="mx-2 normal" @click="annulerMotif">
              <v-icon left>mdi-close</v-icon>
              Annuler
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-col cols="12">
      <BaseBlock title="Liste des candidatures à une formation">
        <v-row>
          <v-col cols="12">
            <v-combobox
              v-model="select"
              :items="items"
              :item-text="displayItem"
              item-value="id"
              @change="getCandidatures"
              label="Sélectionnez une formation"
            ></v-combobox>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-data-table
              :headers="headers"
              :items="candidatures"
              disable-pagination
              hide-default-footer
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              item-key="id"
              class="elevation-1"
              :custom-sort="customSort"
              :search="search"
            >
              <template v-slot:item.etatDemande="{ item }">
                {{ item.etatDemande.libelle }}
                <span
                  v-if="
                    item.etatDemande.id == ETAT.ACCEPTEE.code ||
                      item.etatDemande.id == ETAT.REFUSEE.code ||
                      item.etatDemande.id == ETAT.NON_VALIDE.code ||
                      item.etatDemande.id == ETAT.TRAITEMENT_PEDAGOGIQUE.code
                  "
                >
                  le {{ item.dateDecision }}</span
                >
                <span
                  v-if="
                    item.etatDemande.id == ETAT.CONFIRMEE.code ||
                      item.etatDemande.id == ETAT.DESISTEMENT.code ||
                      item.etatDemande.id == ETAT.ABANDON.code
                  "
                >
                  le {{ item.dateConfirmation }}</span
                >
                <span v-if="item.etatDemande.id == ETAT.FINALISEE.code">
                  le {{ item.dateFinalisation }}</span
                >
              </template>
              <template v-slot:item.action="{ item }">
                <router-link
                  :to="{
                    name: 'candidature-enseignant',
                    params: { idCandidature: item.id, idFormation: select.id }
                  }"
                >
                  <v-icon
                    v-if="
                      item.etatDemande.id > ETAT.TRAITEMENT_PEDAGOGIQUE.code
                    "
                    class="mr-2"
                    title="Visualiser la candidature"
                    >mdi-eye</v-icon
                  >
                  <v-icon v-else class="mr-2" title="Examiner la candidature"
                    >mdi-pencil</v-icon
                  ></router-link
                >

                <v-icon
                  v-if="item.etatDemande.id == ETAT.TRAITEMENT_PEDAGOGIQUE.code"
                  @click="saisieMotifRenvoyer(item.id)"
                  class="mr-2"
                  title="Renvoyer la candidature à l'étudiant"
                  >mdi-account-arrow-left</v-icon
                >
              </template>
              <template v-slot:top>
                <v-row>
                  <v-select
                    v-model="etatFiltre"
                    label="Filtre état demande"
                    :items="etatDemandes"
                    item-value="id"
                    item-text="libelle"
                    class="mx-5"
                  >
                  </v-select>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Recherche"
                    single-line
                    hide-details
                    class="mx-5"
                  ></v-text-field>
                </v-row>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </BaseBlock>
    </v-col>
  </v-row>
</template>

<script>
import BaseBlock from "@/components/base/BaseBlock";

import { EtatDemande } from "@/mixins/EtatDemande.js";
import ListingSort from "@/js_modules/ListingSort";
import ApiCandidatureRepository from "@/repositories/ApiCandidatureRepository";
import ApiFormationRepository from "@/repositories/ApiFormationRepository";
import { mapState } from "vuex";

export default {
  name: "ListeCandidaturesEnseignant",
  components: { BaseBlock },
  mixins: [EtatDemande],
  props: ["idFormation"],
  data() {
    return {
      sortBy: "etatDemande",
      sortDesc: true,
      select: [],
      items: [],
      search: "",

      candidatures: [],

      dialog: false,
      motif: "",
      actionMotif: "",
      idCandidature: 0,
      etatFiltre: "",
      etatDemandes: [
        { id: 0, libelle: "" },
        { id: 3, libelle: "en attente d'examen" },
        { id: 4, libelle: "demande acceptée" },
        { id: 5, libelle: "demande refusée" },
        { id: 6, libelle: "demande non valide" },
        { id: 8, libelle: "demande confirmée" },
        { id: 9, libelle: "désistement" },
        { id: 10, libelle: "demande abandonnée" },
        { id: 11, libelle: "demande finalisée" }
      ]
    };
  },
  watch: {
    etatFiltre(id) {
      sessionStorage.lceEtatFiltre = id;
    }
  },
  async created() {
    if (sessionStorage.lceEtatFiltre) {
      if (sessionStorage.lceEtatFiltre != 0) {
        this.etatFiltre = parseInt(sessionStorage.lceEtatFiltre);
      }
    }
    this.getFormations();
    //this.getCandidatures();
  },
  methods: {
    displayItem(item) {
      let nbCandidaturesATraiter = item.nbCandTrait;
      if (nbCandidaturesATraiter > 0) {
        return item.libelle + " (" + nbCandidaturesATraiter + ")";
      } else {
        return item.libelle;
      }
    },
    customSort: function(items, index, isDesc) {
      return ListingSort.sortEnseignantColumns(items, index, isDesc);
    },
    async getCandidatures() {
      if (this.select !== undefined && this.select.id !== undefined) {
        try {
          const candidatures = await ApiCandidatureRepository.getCandidatures(
            this.select.id
          );
          this.candidatures = candidatures;
        } catch (error) {
          this.$toast.error(error.response.data.messages[0]);
        }
      }
    },
    async getFormations() {
      try {
        const formations = await ApiFormationRepository.getFormationsEnseignant();
        this.items = formations;

        if (this.idFormation && this.idFormation != ":idFormation") {
          this.select = this.items.find(x => x.id == this.idFormation);
        } else {
          this.select = this.items[0];
        }
        this.getCandidatures();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      }
    },
    async renvoyer(idCandidature) {
      try {
        await ApiCandidatureRepository.renvoyerCandidature(
          idCandidature,
          this.motif
        );
        this.$toast.info("La candidature a été renvoyée à l'étudiant.");
        this.getCandidatures();
      } catch (error) {
        this.$toast.error(error.response.data.messages[0]);
      } finally {
        this.motif = "";
        this.idCandidature = 0;
      }
    },
    saisieMotifRenvoyer(idCandidature) {
      this.idCandidature = idCandidature;
      this.dialog = true;
    },
    continuerMotif() {
      this.dialog = false;
      if (this.motif === "") {
        this.$toast.error(
          "Vous devez indiquer la cause du retour du dossier de candidature"
        );
        this.idCandidature = 0;
      } else {
        this.renvoyer(this.idCandidature);
      }
    },
    annulerMotif() {
      this.dialog = false;
      this.idCandidature = 0;
      this.motif = "";
    }
  },
  computed: {
    ...mapState(["user"]),
    headers() {
      return [
        {
          text: "Nom",
          align: "left",
          sortable: true,
          value: "nom"
        },
        {
          text: "Prénom",
          align: "left",
          sortable: true,
          value: "prenom"
        },
        {
          text: "Date de naissance",
          align: "center",
          sortable: true,
          value: "dateNaissance"
        },
        {
          text: "Date de dépôt",
          align: "center",
          sortable: true,
          value: "dateDepot"
        },
        {
          text: "Etat de la demande",
          align: "center",
          sortable: true,
          value: "etatDemande",
          filter: value => {
            if (!this.etatFiltre) return true;
            return value.id == parseInt(this.etatFiltre);
          }
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
          value: "action"
        }
      ];
    }
  }
};
</script>
